import { toExpression } from './processScriptContent';
/**
 * 检查一个字符串是不是带 `{{` 的带花括弧的插值表达式
 *
 * @param {any} str
 * @return {str is string}
 */
export function isInteropableString(str) {
  if (typeof str !== 'string') return false;
  const i = str.indexOf('{{');
  if (i === -1) return false;
  const j = str.indexOf('}}', i);
  return j !== -1;
}
/**
 * 切割带花括弧的插值表达式
 *
 * 返回一个长度为奇数 (>=1) 的字符串数组。其中，奇数项是字符串，偶数项是表达式
 */
export function splitInteropableString(str) {
  const parts = [];
  const offsets = [];
  const answer = {
    parts,
    offsets
  };
  if (typeof str !== 'string' || str.length === 0) {
    parts.push('');
    offsets.push(0);
    return answer;
  }
  let i = 0;
  let j;
  while ((j = str.indexOf('{{', i)) !== -1) {
    const k = str.indexOf('}}', j);
    if (k === -1) break; // 未关闭的表达式，视为字符串
    parts.push(str.slice(i, j), str.slice(j + 2, k));
    offsets.push(i, j + 2);
    i = k + 2;
  }
  parts.push(str.slice(i));
  offsets.push(i);
  return answer;
}
/**
 * 输入一个带花括弧的插值表达式，返回一个带 `return` 的函数体字符串，可以直接用于生成的源代码，或者 `newFunction`
 *
 * @param str 插值表达式（字符串），或者使用 splitInteropString 切割后得到的（字符串数组）
 * @returns 一个表达式（注意！需要自己前面补上 `return` 才能用）
 */
export function compileInteropableString(str) {
  /* istanbul ignore next */
  const parts = Array.isArray(str) ? str : splitInteropableString(str).parts;
  if (parts.length === 1) return `${JSON.stringify(parts[0])}`;
  if (parts.length === 3 && parts[0] === '' && parts[2] === '') {
    return toExpression(parts[1]);
  }
  const answer = [];
  if (parts[0]) answer.push(JSON.stringify(parts[0]));
  for (let i = 2; i < parts.length; i += 2) {
    const expr = parts[i - 1];
    const str = parts[i];
    answer.push(toExpression(expr));
    if (str) answer.push(JSON.stringify(str));
  }
  return `(${answer.join(' + ')})`;
}